import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { GetUserDocumentSubFolderById, saveUserDocumentSubFolder } from '../../../patients/actions/PatientActions';
import { renderCheckBox, renderTextField } from '../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';
//import validate from './validateSubFolder';
import { checkFieldExistence, clearFieldErrorArray } from '../../../AppConfig/actions';
import { MODULE } from '../../constants/ApiConstants';
import { displayCustomError } from '../../../../actions/utilAction';

const validate = (values) => {
  const errors = {};  
  
  if (!values.subFolderName) {
    errors.subFolderName = 'Please enter sub folder name';
  }
  return errors;
};

class SubFoldersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      subFolderId: props.subFolderId,
      userId: props.userId,
      userTypeName: props.userTypeName,
      masterFolderId: props.masterFolderId,
    };
  }

  componentWillMount() {    
    if (this.state.subFolderId) {
      this.props.GetUserDocumentSubFolderById(this.state.subFolderId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    // if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
    //   return null;
    // }
    let postData = {
      "id": this.props.subFolderId || 0,
      "subFolderName": formProps.subFolderName,
      "userId" : this.state.userId,
      "userTypeName" : this.state.userTypeName,
      "isActive":  formProps.isActive || false,
      "masterFolderId" : this.state.masterFolderId,
    }
    this.props.clearFieldErrorArray();
    //console.log('postData............',postData)
    this.props.saveUserDocumentSubFolder(postData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.subFolderId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
    <SubmitButtonModalDisabled label="Loading" /> :
    <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
        submitButton,
      ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.subFolderId
            ? "Edit Sub Folder"
            : "Add Sub Folder"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="subFolderName"
                    type="text"          
                    // onChange={(input, value) => this.checkFieldDataExistence(input, value, 'folder name')}
                    // customError={displayCustomError('FOLDERNAME', this.props.fieldError)}        
                    maxLength="250"
                    label="Sub Folder Name"
                    // normalize={isValidNameWithSpace}
                    component={renderTextField}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field
                    className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

SubFoldersModal = reduxForm({
    form: 'SubFoldersModalForm',
    validate,
    enableReinitialize: true,
})(SubFoldersModal);


function mapStateToProps(state, ownProps) { 

  let initialValueData = {
    isActive: true,
  };
  if (ownProps.subFolderId && state.patient.userDocumentSubFolderDetails) {
    initialValueData = state.patient.userDocumentSubFolderDetails.data || null;
  } 

  return {
    loading: state.patient.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  }
}

export default connect(mapStateToProps,{GetUserDocumentSubFolderById, checkFieldExistence, clearFieldErrorArray, saveUserDocumentSubFolder})(SubFoldersModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/uploadDocuments/subFolders_Modal.js